import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type GetChatRequest = {
  chatId: string;
};

export type GetChatResponse = Chat;

export const getChat = async (params: GetChatRequest): Promise<GetChatResponse> => {
  const { data } = await axios.get(`/chats/${params.chatId}`);

  return data;
};
